<script>
    export let region;
</script>

{#if region === "nz"}
    <div class="alert alert-success" role="alert">
        Card link success! Set up takes up to 10 minutes. Rewards may be delayed
        if you make a transaction in that time. Raiz allows linking of
        four Visa cards. Add cards or remove cards at any time via Settings.
        Ensure notifications are on to receive advice of instant rewards.
    </div>
{:else}
    <div class="alert alert-success" role="alert">
        Card link success! Set up takes up to 10 minutes. Rewards may be delayed
        if you make a transaction in that time. Raiz allows linking of
        four Mastercards and four Visa cards. Add cards or remove cards at any
        time via Settings. Ensure notifications are on to receive advice of
        instant rewards.
    </div>
{/if}
